import { useState, useRef, useMemo, useCallback } from 'react'
import { Icon } from 'leaflet'
import { Marker, Popup } from 'react-leaflet'

interface Props {
	popup?: string
	position: {
		lat: number
		lng: number
	}
	setPosition: (position: { lat: number; lng: number }) => void
}

const MarkerCustomICon = new Icon({
	iconUrl: '/media/icons/kumopack/red-location-marker.svg',
	iconSize: [40, 40],
})

const DraggableMarker: React.FC<Props> = ({ popup, position, setPosition }) => {
	const [draggable, setDraggable] = useState(false)
	const markerRef = useRef<any>(null)

	const eventHandlers = useMemo(
		() => ({
			dragend() {
				const marker = markerRef.current
				if (marker != null) {
					setPosition(marker.getLatLng())
				}
			},
		}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	)

	const toggleDraggable = useCallback(() => {
		setDraggable(d => !d)
	}, [])

	return (
		<Marker
			draggable={draggable}
			eventHandlers={eventHandlers}
			position={position}
			ref={markerRef}
			icon={MarkerCustomICon}>
			{!!popup && (
				<Popup minWidth={90}>
					<span onClick={toggleDraggable}>
						{draggable ? 'Marker is draggable' : 'Click here to make marker draggable'}
					</span>
				</Popup>
			)}
		</Marker>
	)
}

export default DraggableMarker
